/**
 * The video player in Snack Media's ad package (FFH-3483). One tag that the
 * wrapper fills with Sky's player for UK visitors and Primis's for everyone
 * else, and only plays ads once the visitor has consented.
 */

/** The element the wrapper fills with the player. */
export const VIDEO_PLAYER_ID = 'snack-vod';

// Sky's player, measured on staging on 4 November 2026. It is as wide as the
// article column, and from the top: a 16:9 video, a 5px margin, a row of 16:9
// thumbnails 4px apart, then GAM's 1px tag. The row starts with one thumbnail
// and can later fit more: two, three from 380px and four from 490px. Phones
// keep the space for one, the tallest, as they often stay that way. Wider
// screens settled on four within a moment of loading, and every column from
// 768px up is wide enough for four.
const VIDEO_HEIGHT_PER_WIDTH = 9 / 16;
const THUMBNAIL_HEIGHT_PER_WIDTH = 9 / 16;
const THUMBNAIL_GAP_IN_PX = 4;
const MARGIN_AND_TAG_HEIGHT_IN_PX = 6;
const MOBILE_THUMBNAILS_PER_ROW = 1;
const DESKTOP_THUMBNAILS_PER_ROW = 4;

// A padding rather than a height, so that its percentage is of the column's
// width.
const getReservedHeight = (thumbnailsPerRow: number) => {
  const gapsInPx = (thumbnailsPerRow - 1) * THUMBNAIL_GAP_IN_PX;
  const heightPerWidth =
    VIDEO_HEIGHT_PER_WIDTH + THUMBNAIL_HEIGHT_PER_WIDTH / thumbnailsPerRow;
  const fixedHeightInPx =
    MARGIN_AND_TAG_HEIGHT_IN_PX -
    (gapsInPx * THUMBNAIL_HEIGHT_PER_WIDTH) / thumbnailsPerRow;

  return `calc(${heightPerWidth * 100}% + ${fixedHeightInPx}px)`;
};

/**
 * The space the player takes below 768px and from there up, the width at
 * which the ad slots switch too.
 */
export const VIDEO_PLAYER_RESERVED_HEIGHTS = {
  mobile: getReservedHeight(MOBILE_THUMBNAILS_PER_ROW),
  desktop: getReservedHeight(DESKTOP_THUMBNAILS_PER_ROW)
};
